const XP_PLAN_KEY = "decidova:selected-xp-plan";
const XP_WATCH_KEY = "decidova:xp-watch";

export function saveSelectedXpPlan(plan, context = {}) {
  const payload = { plan, context, saved_at: new Date().toISOString() };
  try { localStorage.setItem(XP_PLAN_KEY, JSON.stringify(payload)); } catch {}
  return payload;
}

export function loadSelectedXpPlan() {
  try {
    const raw = localStorage.getItem(XP_PLAN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveXpWatch(plan, context = {}) {
  const payload = { plan, context, saved_at: new Date().toISOString(), type: "xp" };
  try { localStorage.setItem(XP_WATCH_KEY, JSON.stringify(payload)); } catch {}
  return payload;
}

export function loadXpWatch() {
  try {
    const raw = localStorage.getItem(XP_WATCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function clearXpWatch() {
  try { localStorage.removeItem(XP_WATCH_KEY); } catch {}
}
